import React from "react";
import { Container } from "semantic-ui-react";
import HeroBannerCarousel from "../../components/HeroBannerCarousel/HeroBannerCarousel";
import BestsellerSlider from "./BestsellerSlider";

import styles from "./HomePageCustomers.module.scss";
import StartSell from "../HomePageDesigners/StartSell";
import NewArrivals from "./NewArrivals/NewArrivals";
import ShopByStyle from "./ShopByStyle/ShopByStyle";

const HomePageCustomers = () => {
  return (
    <div className={styles.homePageCustomers}>
      <HeroBannerCarousel />
      <div style={{ position: 'relative', zIndex: 1 }}>
        <Container>
          <BestsellerSlider />
          <NewArrivals />
          <ShopByStyle />
        </Container>
        <StartSell />
      </div>
    </div>
  );
};

export default HomePageCustomers;
